<template>
  <div>
    <router-view @page-change="onPageChange" />
  </div>
</template>

<script>
export default {
  name: 'Pei',
  components: {},
  data() {
    return {
      page: {
        type: Object,
        default: () => {},
      },
    };
  },
  methods: {
    onPageChange(page) {
      this.page = page;
    },
  },
};
</script>

<style lang="scss" scoped></style>
